import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import NotFoundPage from '../components/NotFoundPage/NotFoundPage';

const NotFound = ({pagesLeft,pagesRight}) => {
  return (
    <div>
        <Navbar pagesLeft={pagesLeft} pagesRight={pagesRight}></Navbar>
        <NotFoundPage></NotFoundPage>
    </div>
  )
}

export default NotFound